export default "__VITE_ASSET__Cjt7zcXF__"